/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { Text } from '../../../components/Text';
import type { ComponentRendererProps } from '../chakra/shared/Types';

/**
 * Fallback component for unsupported component types
 */
export const UnsupportedComponentRenderer: React.ComponentType<ComponentRendererProps> = ({ node }) => {
  const dtype = 'dtype' in node.component ? node.component.dtype : 'UNKNOWN';
  return (
    <Text variant="caption" color="text.primary">
      Unsupported component type: {node.component.ctype} / {dtype}
    </Text>
  );
};
